import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import { useFeatures } from '../hooks/Features/useFeatures'
import { useCustomerType } from '../hooks/CompanyConfiguration/useCustomerType'
import CustomerTypeView from '../components/version-4/viewForms/CustomerTypeView'
import { ROUTES } from '../shared/constants'

function ViewCustomerType() {
  const { customerType, getCustomerType } = useCustomerType()
  const params = useParams()
  React.useEffect(() => {
    getCustomerType({ customerTypeId: params.customerTypeId })
  }, [params.customerTypeId])

  return (
    <Layout heading="Customer Type" heading2="Info" url1={ROUTES.CUSTOMERTYPE} none>
      {customerType ? (
        <HeaderTabLayout
          heading="Customer Type"
          content={<CustomerTypeView customerType={customerType} />}
          view
          url={`/edit-customerType/${params.customerTypeId}`}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}

export default ViewCustomerType
